<template>
  <v-dialog
    v-model="dialog"
    max-width="760"
    content-class="image-lightbox"
    @click:outside="close"
  >
    <div class="text-center">
      <div class="lightbox-frame">
        <v-btn class="lightbox-close" icon dark small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <img v-if="src" class="lightbox-image" :src="src" :alt="alt" />
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "ImageLightbox",

  data() {
    return {
      dialog: false,
      src: null,
      alt: ""
    };
  },

  mounted() {
    this.$root.$on("showImage", this.show);
  },

  beforeDestroy() {
    this.$root.$off("showImage", this.show);
  },

  methods: {
    show(payload) {
      const src =
        typeof payload === "string" ? payload : payload && payload.src;

      if (!src) return;

      this.src = src;
      this.alt = (payload && payload.alt) || "";
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style>
.v-dialog.image-lightbox {
  box-shadow: none;
  overflow: visible;
}
</style>

<style scoped>
.lightbox-image {
  display: block;
  max-width: 100%;
  max-height: 80vh;
  margin: 0 auto;
  border-radius: 8px;
}

/*the dialog clips anything outside its box, keep the button over the image*/
.lightbox-frame {
  position: relative;
  display: inline-block;
  max-width: 100%;
}

.lightbox-close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  background: rgba(0, 0, 0, 0.55);
}
</style>
